import type { FitnessWorkoutExercise } from '@/lib/fitnessWorkoutController';
import { useLanguage } from '@/i18n/LanguageProvider';
import { localizeFitnessProductExerciseName } from '@/lib/fitnessProductExerciseLabels';
import { getFitnessWorkoutExperienceCopy } from '@/lib/fitnessWorkoutExperienceCopy';
import { getFitnessGuidedCopy } from '@/lib/fitnessGuidedCopy';
export default function FitnessWorkoutSequence({ exercises, currentIndex }: { exercises: readonly FitnessWorkoutExercise[]; currentIndex: number }) {
  const { lang, t } = useLanguage(), copy = getFitnessWorkoutExperienceCopy(lang), guided = getFitnessGuidedCopy(lang);
  return <section className="rounded-2xl border border-border bg-card p-4">
    <h3 className="mb-3 font-semibold">{copy.sequence}</h3>
    <ol className="max-h-80 space-y-3 overflow-y-auto">
      {exercises.map((exercise,index) => <li key={index} aria-current={index === currentIndex ? 'step' : undefined}
        className={'rounded-xl border p-3 text-sm ' + (index === currentIndex ? 'border-primary bg-primary/5' : 'border-border')}>
        <p className="font-medium">{localizeFitnessProductExerciseName(exercise.name,lang) ?? (exercise.name.startsWith('fitness.') ? t(exercise.name) : exercise.name)}</p>
        <p className="mt-1 text-xs text-muted-foreground">{exercise.sets.filter(set => set.done).length}/{exercise.sets.length} {copy.completed}
          {exercise.groupId && <> · {exercise.groupType === 'circuit' ? guided.circuit : guided.superset}</>}
        </p>
      </li>)}
    </ol>
  </section>;
}
